import React, { useState, useEffect } from 'react';
import { BsChevronCompactLeft, BsChevronCompactRight } from 'react-icons/bs';
import { RxDotFilled } from 'react-icons/rx';
import SlideOne from "../assets/slide1.jpg";
import SlideTwo from "../assets/slide2.jpg";
import SlideThree from "../assets/slide3.jpg";
import SlideFour from "../assets/slide4.jpg";

const Slide = () => {

    const slides = [
        SlideOne,
        SlideTwo,
        SlideThree,
        SlideFour
    ];

    const [currentIndex, setCurrentIndex] = useState(0);

    const prevSlide = () => {
        const isFirstSlide = currentIndex === 0;
        const newIndex = isFirstSlide ? slides.length - 1 : currentIndex - 1;
        setCurrentIndex(newIndex);
    };
    
    const nextSlide = () => {
        const isLastSlide = currentIndex === slides.length - 1;
        const newIndex = isLastSlide ? 0 : currentIndex + 1;
        setCurrentIndex(newIndex);
    };
    
    const goToSlide = (slideIndex) => {
        setCurrentIndex(slideIndex);
    };

    useEffect(() => {
        const slideInterval = setInterval(() => {
            nextSlide();
        }, 5000); // Change every 5 seconds (5000 milliseconds)

        // Cleanup the interval when the component unmounts
        return () => {
            clearInterval(slideInterval);
        };
    }, [currentIndex]);
    
    return(
        <div className=' h-full w-full pt-8 relative group'>
            
            <img 
            src={slides[currentIndex]}
            alt={`Slide ${currentIndex}`}
            className='w-full md:h-[520px] rounded-2xl duration-500 p-5 flex justify-center sm:h-full'
            />

            {/* Left Arrow */}
            <div className='hidden group-hover:block absolute top-[50%] -translate-x-0 translate-y-[-50%] left-5 text-2xl rounded-full p-2 bg-black/20 text-white cursor-pointer'>
                <BsChevronCompactLeft onClick={prevSlide} size={30} />
            </div>

            {/* Right Arrow */}
            <div className='hidden group-hover:block absolute top-[50%] -translate-x-0 translate-y-[-50%] right-5 text-2xl rounded-full p-2 bg-black/20 text-white cursor-pointer'>
                <BsChevronCompactRight onClick={nextSlide} size={30} />
            </div>

            <div className='flex top-4 justify-center py-2'>
                {slides.map((slide, slideIndex) => (
                    <div
                    key={slideIndex}
                    onClick={() => goToSlide(slideIndex)}
                    className='text-2xl cursor-pointer'
            >
            <RxDotFilled />
          </div>
        ))}
      </div>
    </div>
    )
}

export default Slide;